import React from 'react';
import DatePicker from 'react-16-bootstrap-date-picker';
import { Button, Col, Collapse, ControlLabel, FormControl, FormGroup, Glyphicon, Row } from 'react-bootstrap';
import Select from 'react-select';
import PracticeSearchModal from '../../Shared/PracticeSearchModal';
import ProviderSearchModal from '../../Shared/ProviderSearchModal';
import WorkflowSectionHeader from './WorkflowSectionHeader';

class AppointmentInfo extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            showPracticeSearchModal: false,
            showProviderSearchModal: false
        };
    }

    handleAppointmentDateChange = (e) => {
        this.props.handleWorkflowFieldChange({ appointmentDate: e });
    }

    handleAltProviderLastNameChange = (e) => {
        this.props.handleWorkflowFieldChange({ altProviderLastName: e.target.value });
    }

    handleAltProviderFirstNameChange = (e) => {
        this.props.handleWorkflowFieldChange({ altProviderFirstName: e.target.value });
    }

    togglePracticeSearchModal = () => {
        this.setState({ showPracticeSearchModal: !this.state.showPracticeSearchModal });
    }

    getPracticeOptions = () => {
        return this.props.practices.map((item) => {
            return { value: item.groupingID, label: item.description }
        });
    }

    handlePracticeChange = (e) => {
        let selectedValue = '';
        if (e) {
            //uses the practice object when caller is the search modal
            selectedValue = e.value ? e.value : e;
        }
        this.props.handleWorkflowPracticeChange(selectedValue);
    }

    toggleProviderSearchModal = () => {
        this.setState({ showProviderSearchModal: !this.state.showProviderSearchModal });
    }

    getProviderOptions = () => {
        return this.props.practiceProviders.map((item) => {
            return { value: item.internalKey, label: `${item.lastName}, ${item.firstName}` }
        });
    }

    handleProviderChange = (e) => {
        this.props.handleWorkflowFieldChange({ appointmentProviderMasterID: e ? e.value : '' });
    }

    handleProviderModalSelect = (internalKey, providerID, providerNPI, lastName, firstName) => {
        this.props.attachProviderToPractice(internalKey);
    }

    getAppointmentTypeOptions = () => {
        return this.props.appointmentTypes.map((item) => {
            return { value: item.appointmentTypeID, label: item.appointmentTypeDesc }
        });
    }

    handleAppointmentTypeChange = (e) => {
        this.props.onAppointmentTypeChange(e ? e.value : '');
    }

    render() {
        return (
            <div className="alert-workflow-subcontainer">
                <WorkflowSectionHeader expanded={this.props.expanded} toggle={this.props.toggleSection}
                    toggleKey="appointment" title="Appointment" />
                <Collapse in={this.props.expanded}>
                    <div style={{ paddingLeft: '0.5rem', paddingRight: '0.5rem' }}>
                        <Row>
                            <Col xs={3}>
                                <FormGroup>
                                    <ControlLabel>Appointment Practice</ControlLabel>
                                    <Row style={{ margin: 0 }}>
                                        <Col xs={11} style={{ paddingRight: '0.2rem', paddingLeft: '0rem' }}>
                                            <Select value={this.props.workflow.appointmentPracticeCode} options={this.getPracticeOptions()}
                                                onChange={this.handlePracticeChange} disabled={this.props.isViewOnly} />
                                        </Col>
                                        <Col xs={1} style={{ paddingRight: '0rem', paddingLeft: '0rem' }}>
                                            <Button onClick={this.togglePracticeSearchModal} bsSize="small" disabled={this.props.isViewOnly}
                                                style={{ height: '3.4rem', minWidth: '4rem', width: '100%' }}>
                                                    <Glyphicon glyph="search" />
                                            </Button>
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Col>
                            <Col xs={3}>
                                <FormGroup>
                                    <ControlLabel>Appointment Provider</ControlLabel>
                                    <Row style={{ margin: 0 }}>
                                        <Col xs={11} style={{ paddingRight: '0.2rem', paddingLeft: '0rem' }}>
                                            <Select value={this.props.workflow.appointmentProviderMasterID} options={this.getProviderOptions()}
                                                disabled={this.props.providerDropdownDisabled || !this.props.workflow.appointmentPracticeCode
                                                    || this.props.isViewOnly} onChange={this.handleProviderChange} />
                                        </Col>
                                        <Col xs={1} style={{ paddingRight: '0rem', paddingLeft: '0rem' }}>
                                            <Button onClick={this.toggleProviderSearchModal} bsSize="small" disabled={this.props.isViewOnly}
                                                style={{ height: '3.4rem', minWidth: '4rem', width: '100%' }}>
                                                    <Glyphicon glyph="search" />
                                            </Button>
                                        </Col>
                                    </Row>
                                </FormGroup>
                            </Col>
                            <Col xs={3}>
                                <FormGroup>
                                    <ControlLabel>Appointment Type</ControlLabel>
                                    <Select value={this.props.workflow.appointmentTypeID} options={this.getAppointmentTypeOptions()}
                                        onChange={this.handleAppointmentTypeChange} disabled={this.props.isViewOnly} />
                                </FormGroup>
                            </Col>
                            <Col xs={3}>
                               <FormGroup>
                                    <ControlLabel style={{ marginRight: '1rem' }}>Appointment Date</ControlLabel>
                                    <DatePicker value={this.props.workflow.appointmentDate} onChange={this.handleAppointmentDateChange}
                                        style={{ zIndex: 'auto' }} disabled={this.props.isViewOnly} />
                               </FormGroup>
                            </Col>
                        </Row>
                        <Row>
                            <Col xs={3}>
                                <FormGroup>
                                    <ControlLabel>Alternate Provider Last Name</ControlLabel>
                                    <FormControl type="text" value={this.props.workflow.altProviderLastName ? this.props.workflow.altProviderLastName : ''}
                                        maxLength="50" onChange={this.handleAltProviderLastNameChange} disabled={this.props.isViewOnly} />
                                </FormGroup>
                            </Col>
                            <Col xs={3}>
                                <FormGroup>
                                    <ControlLabel>Alternate Provider First Name</ControlLabel>
                                    <FormControl type="text" value={this.props.workflow.altProviderFirstName ? this.props.workflow.altProviderFirstName : ''}
                                        maxLength="50" onChange={this.handleAltProviderFirstNameChange} disabled={this.props.isViewOnly} />
                                </FormGroup>
                            </Col>
                        </Row>
                    </div>
                </Collapse>
                <PracticeSearchModal visible={this.state.showPracticeSearchModal} handleModalToggle={this.togglePracticeSearchModal}
                    handleSelectSearchResult={this.handlePracticeChange} toast={this.props.toast} />
                <ProviderSearchModal visible={this.state.showProviderSearchModal} handleModalToggle={this.toggleProviderSearchModal}
                    handleSelectSearchResult={this.handleProviderModalSelect} toast={this.props.toast} />
            </div>
        );
    }
}

export default AppointmentInfo;